import {ChartOptionType} from '../dashboard/dashboard.types';

export function shouldAutoEnablePeakPower(chartOptionType: ChartOptionType): boolean {
    return chartOptionType === ChartOptionType.Electricity;
}
